<template>
	<div>
		<mainHead :title="mainHeadTitle" @btnClick="addTableData" :hasPermiDict="hasPermiDict"></mainHead>
		<div class="mianPage">
			<el-form inline class="el-form flex_start">
				<el-form-item label="日期：">
					<el-date-picker v-model="datePicker" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
					start-placeholder="开始日期" end-placeholder="结束日期" size="small">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="APP ID/名称：">
					<el-select v-model="queryData.appId" clearable size="small" style="width:210px">
						<el-option v-for="item in appSelectData" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<div class="menu-right">
					<el-button @click="searchReset" size="small" v-hasPermi="['SDKVersion:SDKVersion:query']">重置</el-button>
					<el-button type="primary" @click="confirmQuery" size="small" v-hasPermi="['SDKVersion:SDKVersion:query']">查询</el-button>
				</div>
			</el-form>
			<el-table :max-height="560" :header-cell-style="{color:'#333333',background:'#EAEFF5'}" :data="tableData"
				class="el_table">
				<el-table-column prop="addTime" label="时间"></el-table-column>
				<el-table-column prop="appName" label="APP名称">
					<template slot-scope="scope">
						<div>{{scope.row.appName}}/{{scope.row.appId}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="appPackage" label="APP包名"></el-table-column>
				<el-table-column prop="version" label="SDK版本"></el-table-column>
				<el-table-column prop="versionCode" label="SDK版本号"></el-table-column>
				<el-table-column prop="downloadUrl" label="下载地址"></el-table-column>
				<el-table-column prop="forceUpdate" label="更新类型">
					<template slot-scope="scope">
						<div v-if="scope.row.forceUpdate==1">非强制</div>
						<div v-if="scope.row.forceUpdate==2">强制</div>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="" label="操作" fixed="right" width="150">
					<template slot-scope="scope">
						<el-button type="text" @click="editTable(scope.row,scope.$index)">编辑</el-button>
						<el-button type="text" @click="channelManage(scope.row)">配置</el-button>
					</template>
				</el-table-column> -->
			</el-table>
			<div class="paging" style="display: flex;justify-content: flex-end;margin-top: 20px;">
				<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange" :current-page="currentPage"
					:page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
			</div>
		</div>
		<el-dialog title="SDK版本添加" :visible.sync="dialogVisible" width="28%">
			<el-form inline class="el-form el_dialog_form" label-width="120px" :rules="appRulesApi" :model="appFormData"
				ref="ruleAPPForm">
				<el-form-item label="所属应用：" prop="appId">
					<el-select v-model="appFormData.appId" clearable size="small">
						<el-option v-for="item in appSelectData" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="SDK版本：" prop="version">
					<el-input clearable size="small" placeholder="请输入" v-model="appFormData.version"></el-input>
				</el-form-item>
				<el-form-item label="SDK版本号：" prop="versionCode">
					<el-input clearable size="small" placeholder="请输入" v-model="appFormData.versionCode"></el-input>
				</el-form-item>
				<el-form-item label="下载地址：" prop="downloadUrl">
					<el-input type="textarea" :rows="2" clearable size="small" placeholder="请输入"
					v-model="appFormData.downloadUrl"></el-input>
				</el-form-item>
				<el-form-item label="强制更新：" prop="forceUpdate">
					<el-select v-model="appFormData.forceUpdate" clearable size="small">
						<el-option label="非强制" :value="1"></el-option>
						<el-option label="强制" :value="2"></el-option>
					</el-select>
				</el-form-item>
				<div class="card-bottom flex_end">
					<el-button @click="closeAPPDialog" size="medium">取消</el-button>
					<el-button type="primary" @click="confirmAPP('ruleAPPForm')" size="medium">确定</el-button>
				</div>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				mainHeadTitle: 'SDK版本管理',
				hasPermiDict: 'SDKVersion:SDKVersion:add',
				datePicker: [],
				appSelectData: [], // APP下拉选择列表
				queryData: {
					appId: ''
				},
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				appRulesApi: {
					appId: [{required: true,message: '请选择所属应用',trigger: 'blur'}],
					version: [{required: true,message: '请输入SDK版本',trigger: 'blur'}],
					versionCode: [{required: true,message: '请输入SDK版本号',trigger: 'blur'}],
					downloadUrl: [{required: true,message: '请输入下载地址',trigger: 'blur'}],
					forceUpdate: [{required: true,message: '请选择是否强制更新',trigger: 'blur'}],
				},
				appFormData: {
					isList: 1
				},

				dialogVisible: false, // 弹框显隐
			}
		},
		mounted() {
			this.getAppOption();
			this.getTableData();
		},
		methods: {
			async getTableData() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize,
					// appId: this.queryData.appId,
					startTime: '',
					endTime: '',
				}
				if (this.datePicker && this.datePicker.length>0) {
					data.startTime = this.datePicker[0];
					data.endTime = this.datePicker[1];
				}
				data = {...data,...this.queryData}
				let res = await this.$http.post(this.$api.sdkVersion, data);
				this.tableData = res.data.list
				this.total = res.data.totalRecord
			},
			async getAppOption(){
				let res = await this.$http.get(this.$api.common.mediaAppOption);
				if(res.code == 1){
					this.appSelectData = res.data
				}
			},
			handleSizeChange(val) {
				this.currentPage = 1
				this.pageSize = val
				this.getTableData();
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getTableData();
			},
			searchReset() {
				this.currentPage = 1
				this.datePicker = []
				this.queryData = {
					appId: ''
				}
				this.getTableData();
			},
			confirmQuery() {
				this.currentPage = 1
				this.getTableData();
			},
			// 新增表格信息
			addTableData() {
				this.appFormData = {}
				this.isAdEditDialog = false
				this.dialogVisible = true
			},
			// 编辑表格信息
			editTable(row, index) {
				this.appFormData = row
				this.isAdEditDialog = true
				this.dialogVisible = true
			},
			// 表格弹窗关闭
			closeAPPDialog() {
				this.dialogVisible = false
			},
			// app新增确认
			confirmAPP(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						let data = this.appFormData;
						let res = await this.$http.post(this.$api.sdkVersionAdd, data);
						if(res.code == 1){
							this.$message.success('添加成功');
						}
						this.closeAPPDialog();
						this.getTableData();
					}
				});
			},
		},
	}
</script>

<style scoped>
	.mianPage {
		margin: 20px;
		background: #FFFFFF;
		border-radius: 4px;
		padding: 24px;
	}

	.el-form {
		flex-wrap: wrap;
	}

	/deep/ .el-form--inline .el-form-item {
		margin-right: 20px !important;
	}

	.menu-right {
		margin-left: auto;
		margin-top: 4px;
		margin-bottom: 22px;
	}

	.cardTitle {
		font-weight: 500;
		font-size: 22px;
		color: #000000;
	}

	.cardTitle i {
		cursor: pointer;
	}

	.cardTitleTxt {
		font-size: 16px;
	}

	.box-card {
		height: 100%;
	}

	.box-card /deep/ .el-form--inline .el-form-item {
		display: block !important;
	}

	.card-bottom {
		padding-right: 30px;
	}




	.pageTopBox {
		height: 54px;
		width: 100%;
		/* border-left: 3px solid #4568dc; */
		box-shadow: 0 3px 15px rgb(0 0 0 / 5%);
		padding: 0 20px;
		box-sizing: border-box;
		background: #FFFFFF;
		align-items: center;
	}

	.addBtn {
		padding-right: 5px;
	}

	.titleText {
		font-family: PingFang SC, PingFang SC;
		line-height: 54px;
		font-weight: 500;
		font-size: 18px;
		color: #333333;
	}

	.crumbsText {
		margin-left: auto;
		font-size: 14px;
		line-height: 54px;
		cursor: pointer;
		color: #4568dc;
	}

	.crumbsText span {
		color: #6c757d;
		cursor: auto;
	}

	.drawerTable {
		margin: 20px 0;
		/* padding: 10px; */
		box-sizing: border-box;
	}

	.box-card /deep/ .el-card__body {
		box-sizing: border-box;
	}
</style>